<h2 mat-dialog-title>Add a SKU</h2>
<mat-dialog-content>
  <div class="modal-inputs">
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input matInput #skuNameInput>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Description</mat-label>
      <input matInput #descriptionInput>
    </mat-form-field>

    <mat-checkbox #enabledInput>Enabled</mat-checkbox>

    <mat-form-field>
      <mat-label>Solutions</mat-label>
      <mat-select #solutionsSelect multiple>
        <mat-option value="BOBA">BOBA</mat-option>
        <mat-option value="DPC">DPC</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="modal-btn-group">
    <button mat-dialog-close color="primary" class="secondary-btn mb-15 mr-15">
      Cancel
    </button>
    <button mat-flat-button (click)="addSku()" cdkFocusInitial color="primary" class="primary-btn mb-15 mr-15">
      Add SKU
    </button>
  </div>
</mat-dialog-actions>
